import { HTTP } from "@/shared/services/Http.service";
import type { BuscarContactoRequest, GetAbogadosPorMatriculaCedulaRequest, GetAbogadosPorMatriculaCedulaResponse } from "../../types/interfaces/ApiConsultaGestionCasos/Contactos";
import { URL_API_CONSULTA_GESTION_CASOS } from "../../utils/Url.utils";

const http = HTTP();

function BuscarCrm(data: BuscarContactoRequest):Promise<any>{
    return http.Post(`${URL_API_CONSULTA_GESTION_CASOS.BUSCAR_CRM}`, {body: data, skipAuth: true})
}
function GetAbogadosPorMatriculaCedula(data: GetAbogadosPorMatriculaCedulaRequest):Promise<GetAbogadosPorMatriculaCedulaResponse>{
    return http.Post(`${URL_API_CONSULTA_GESTION_CASOS.GET_ABOGADOS_POR_MATRICULA_CEDULA}`, {body: data})
}

function validarExisteAbogadoPorMatriculaCedula(params: {Matricula: string, Cedula: string}):Promise<boolean>{
    return http.Get(`${URL_API_CONSULTA_GESTION_CASOS.VALIDAR_EXISTE_ABOGADO_POR_MATRICULA_CEDULA}?Matricula=${params.Matricula}&Cedula=${params.Cedula}`)
}

export{
    BuscarCrm,
    GetAbogadosPorMatriculaCedula,
    validarExisteAbogadoPorMatriculaCedula
}